<template>
  <div>
    <template v-if="schema.fields.length">
      <Toast position="bottom-left" />
      <Breadcrumb class="p-mb-3" :home="home" :model="breadcrumbItems" />

      <TabView>
        <TabPanel header="اطلاعات پایه">
          <div class="panel-body">
            <form ref="form" @submit.prevent="submitForm" method="POST">
              <vue-form-generator
                :schema="schema"
                :model="model"
                :options="formOptions"
                @validated="onValidated"
              ></vue-form-generator>
              <br />
              <Button
                type="submit"
                :disabled="submiting || !isValid"
                class="p-button-success p-mr-2"
                >{{ !submiting ? "ذخیره تغییرات" : "در حال ارسال" }}</Button
              >
              <router-link :to="`/List/${moduleName}`">
                <Button
                  label=" بازگشت به لیست"
                  class="p-button-outlined p-mr-1"
                />
              </router-link>

              <router-link :to="`/Create/${moduleName}`">
                <Button label="آیتم جدید" class="p-button-outlined p-mr-1" />
              </router-link>
            </form>
          </div>
        </TabPanel>
        <TabPanel header="مدیا" v-if="hasMedia">
          <TabView v-if="mediaTypeList">
            <TabPanel
              :key="mediaType"
              v-for="mediaType of mediaTypeList"
              :header="mediaType"
            >
              <FileUpload
                @upload="onUploadCompleted"
                name="files[]"
                :url="`${baseUrl}/api/media/upload/${moduleName}/${mediaType}/${model.Id}`"
                :multiple="true"
                :maxFileSize="100000000"
                chooseLabel="انتخاب فایل"
                uploadLabel="آپلود"
                cancelLabel="لغو"
              >
                <template #empty>
                  <p>برای آپلود {{ mediaType }} را اینجا رها کنید</p>
                </template>
              </FileUpload>

              <div
                class="p-fileupload-content p-mr-4 p-mt-5"
                v-if="model.Medias"
              >
                <div class="p-fileupload-files">
                  <div
                    class="p-fileupload-row"
                    v-for="file of model.Medias.filter(
                      (m) => m.mediaType == mediaType
                    )"
                    :key="file.id"
                  >
                    <div>
                      <img
                        role="presentation"
                        :alt="file.fileName"
                        :src="`${baseUrl}/files/${moduleName}/${file.mediaType}/${file.rowId}/${file.fileName}`"
                        :width="50"
                      />
                    </div>
                    <div></div>
                    <div dir="ltr" class="p-text-right">
                      {{ file.fileName }}
                    </div>
                    <div>
                      <Button
                        type="button"
                        class="p-button-danger"
                        icon="pi pi-times"
                        @click="removeMedia(file.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </TabPanel>
      </TabView>
    </template>
    <template v-else>
      <ProgressBar mode="indeterminate" class="p-mt-5" />
    </template>
  </div>
</template>

<script>
import CrudService from "@/service/CrudService";
import MediaService from "@/service/MediaService";
import "@/assets/layout/form-generator.scss";
import { getters } from "./../../store.js";
import VueFormGenerator from "vue-form-generator";
import resources from "./../../resources";
import formatter from "./formatter";
import helper from "../../helper";

export default {
  data() {
    return {
      isValid: true,
      moduleName: null,
      hasMedia: false,
      mediaTypes: null,
      moduleLabel: null,
      home: { icon: "pi pi-home", to: "/" },
      breadcrumbItems: [],
      submiting: false,
      schema: { fields: [] },
      model: {},
      baseUrl:
        process.env.NODE_ENV === "production"
          ? "https://nextapi.logonomy.ir"
          : "http://localhost:5051",
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true,
      },
    };
  },
  crudService: null,
  mediaService: null,
  watch: {
    $route(to) {
      this.crudService = new CrudService(to.params.module, this);

      this.moduleName = to.params.module;
      this.setBreadcrumb();
    },
  },
  computed: {
    mediaTypeList() {
      return this.mediaTypes.split(",");
    },
    ...getters,
  },
  methods: {
    onValidated(isValid) {
      this.isValid = isValid;
    },
    onUploadCompleted(event) {
      const files = JSON.parse(event.xhr.response);
      this.model.Medias = this.model.Medias.concat(files);
    },
    setBreadcrumb() {
      this.moduleLabel = this.modules.filter(
        (x) => x.name == this.moduleName
      )[0].label;

      this.breadcrumbItems = [];

      this.breadcrumbItems.push({
        label: this.moduleLabel,
        to: `/List/${this.moduleName}`,
      });
      this.breadcrumbItems.push({
        label: "ویرایش",
        to: `/Edit/${this.moduleName}/${this.$route.params.id}`,
      });
    },

    async submitForm() {
      if (!this.isValid) return;
      this.submiting = true;
      const object = formatter.reformModelBeforePost(this.model, this.schema);
      const success = await this.crudService.update(object);
      helper.toastSubmitResult(success, this.$toast);
      this.submiting = false;
    },

    async removeMedia(id) {
      const result = await this.mediaService.removeFile(id, this.moduleName);
      helper.toastDeleteResult(result, this.$toast);
      if (result)
        this.model.Medias = this.model.Medias.filter((x) => x.id != id);
    },
  },

  async created() {
    this.moduleName = this.$route.params.module;

    this.setBreadcrumb();
    const module = this.modules.find((x) => x.name == this.moduleName);
    this.hasMedia = module.hasMedia;
    this.mediaTypes = module.mediaTypes;

    this.mediaService = new MediaService(this);
    this.crudService = new CrudService(this.moduleName, this);
    let fields = await this.crudService.getMetaData();

    formatter.setupCustomFields(fields);

    this.schema.fields = fields;
    const model = await this.crudService.getItem(this.$route.params.id);

    this.model = formatter.reformModelAfterGet(model, fields, this.moduleName);

    let res = VueFormGenerator.validators.resources;
    for (const key in res)
      VueFormGenerator.validators.resources[key] = resources[key];
  },
};
</script>

<style lang="scss" scoped>
</style>

